import React from 'react';
import { withContent } from '../../../hoc/withContext';
import './TitleElement.scss';
import { IContent } from '../../../types';
import { getShopURL } from '../../../utils';

interface ITitleElementProps {
  context?: IContent;
  children?: any;
}

const TitleElement = ({ children }: ITitleElementProps) => {
  let content = children;
  const linkRegex = /<a href="([^"].*?)"/g;
  const matches = linkRegex.exec(content);
  if (matches !== null) {
    content = content.replace(matches[1], getShopURL() + matches[1]);
  }
  return (
    <h2 className="ubiforward-title" dangerouslySetInnerHTML={{ __html: content }} />
  );
};

export default withContent(TitleElement);
